(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["filter-tooltip"] && !Shopify.designMode) return;
  try {
    if (!window.FWFilterTooltip) {
    window.FWFilterTooltip = {
      close(panel) {
        if (!panel) return;

        panel.hidden = true;
        panel.style.maxHeight = '';
        panel.style.left = '';
        panel.style.top = '';
      },

      closeAll(except) {
        document.querySelectorAll('.fw-filter-tooltip__panel:not([hidden])').forEach((panel) => {
          if (panel !== except) this.close(panel);
        });
      },

      position(button, panel) {
        if (!button || !panel) return;

        const viewportPadding = 16;
        const tooltipGap = 8;
        const buttonRect = button.getBoundingClientRect();
        const availableBelow = window.innerHeight - viewportPadding - buttonRect.bottom - tooltipGap;
        const availableAbove = buttonRect.top - viewportPadding - tooltipGap;

        panel.hidden = false;
        panel.style.maxHeight = '';

        // Measure natural size at origin before placing.
        let panelRect = panel.getBoundingClientRect();
        const shouldOpenAbove = panelRect.height > availableBelow && availableAbove > availableBelow;

        const availableHeight = shouldOpenAbove ? availableAbove : availableBelow;
        const clampedHeight = Math.min(Math.max(availableHeight, 0), window.innerHeight - viewportPadding * 2);

        if (clampedHeight > 0) {
          panel.style.maxHeight = `${clampedHeight}px`;
        }

        panelRect = panel.getBoundingClientRect();

        // Anchor the panel's right edge under the button's right edge, then
        // clamp into the viewport. position:fixed => coords are viewport-relative.
        let left = buttonRect.right - panelRect.width;
        if (left + panelRect.width > window.innerWidth - viewportPadding) {
          left = window.innerWidth - viewportPadding - panelRect.width;
        }
        if (left < viewportPadding) {
          left = viewportPadding;
        }

        const top = shouldOpenAbove
          ? buttonRect.top - tooltipGap - panelRect.height
          : buttonRect.bottom + tooltipGap;

        panel.style.left = `${Math.round(left)}px`;
        panel.style.top = `${Math.round(top)}px`;
      },

      toggle(button) {
        const panel = button?.nextElementSibling;
        if (!(panel instanceof HTMLElement)) return;

        const shouldOpen = panel.hidden;
        this.closeAll(panel);

        if (!shouldOpen) {
          this.close(panel);
          return;
        }

        this.position(button, panel);
      },

      repositionOpenPanels() {
        document.querySelectorAll('.fw-filter-tooltip__panel:not([hidden])').forEach((panel) => {
          const button = panel.previousElementSibling;

          if (button instanceof HTMLElement) {
            this.position(button, panel);
          }
        });
      },
    };

    document.addEventListener('click', (event) => {
      if (event.target instanceof Element && event.target.closest('.fw-filter-tooltip')) return;
      window.FWFilterTooltip.closeAll();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        window.FWFilterTooltip.closeAll();
      }
    });

    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      document.addEventListener('mouseover', (event) => {
        const tooltip = event.target instanceof Element ? event.target.closest('.fw-filter-tooltip') : null;
        if (!tooltip || tooltip.contains(event.relatedTarget)) return;

        const button = tooltip.querySelector('.fw-product-selector__info-btn');
        const panel = tooltip.querySelector('.fw-filter-tooltip__panel');
        if (!button || !panel || !panel.hidden) return;

        window.FWFilterTooltip.closeAll(panel);
        window.FWFilterTooltip.position(button, panel);
      });

      document.addEventListener('mouseout', (event) => {
        const tooltip = event.target instanceof Element ? event.target.closest('.fw-filter-tooltip') : null;
        if (!tooltip || tooltip.contains(event.relatedTarget)) return;

        window.FWFilterTooltip.close(tooltip.querySelector('.fw-filter-tooltip__panel'));
      });
    }

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (!document.querySelector('.fw-filter-tooltip__panel:not([hidden])')) return;
        window.FWFilterTooltip.repositionOpenPanels();
      }, 100);
    });

    // Panel is position:fixed; page scroll moves the anchor button away from it.
    // Skip when the scroll originates inside the panel's own overflow content.
    window.addEventListener('scroll', (event) => {
      if (event.target instanceof Element && event.target.closest('.fw-filter-tooltip__panel')) return;
      if (!document.querySelector('.fw-filter-tooltip__panel:not([hidden])')) return;
      window.FWFilterTooltip.closeAll();
    }, true);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fw-linked-colour-swatches"] && !Shopify.designMode) return;
  try {
    (() => {
    const selectedVariantTitle = (swatch) => {
      const scope = swatch.closest('.shopify-section, dialog') || document;
      const variantJson = scope.querySelector('variant-picker script[type="application/json"]');
      if (!variantJson) return null;
      try {
        return JSON.parse(variantJson.textContent)?.title ?? null;
      } catch (error) {
        return null;
      }
    };

    const setName = (swatch, name) => {
      const label = swatch.closest('.fw-colour-swatches')?.querySelector('[data-fw-colour-name]');
      if (label) label.textContent = name ?? label.dataset.current;
    };

    document.addEventListener('click', (event) => {
      const swatch = event.target.closest('[data-fw-colour-swatch]');
      if (!swatch) return;
      if (swatch.getAttribute('aria-current') === 'true') {
        event.preventDefault();
        return;
      }
      const title = selectedVariantTitle(swatch);
      const variantsJson = swatch.querySelector('[data-fw-colour-variants]');
      if (!title || !variantsJson) return;
      let match = null;
      try {
        match = JSON.parse(variantsJson.textContent)[title] ?? null;
      } catch (error) {
        return;
      }
      if (!match || !match.available) return;
      const url = new URL(swatch.href, window.location.origin);
      url.searchParams.set('variant', match.id);
      swatch.href = url.toString();
    });

    ['mouseover', 'focusin'].forEach((type) =>
      document.addEventListener(type, (event) => {
        const swatch = event.target.closest('[data-fw-colour-swatch]');
        if (swatch) setName(swatch, swatch.dataset.name);
      })
    );

    ['mouseout', 'focusout'].forEach((type) =>
      document.addEventListener(type, (event) => {
        const swatch = event.target.closest('[data-fw-colour-swatch]');
        if (swatch && !swatch.contains(event.relatedTarget)) setName(swatch, null);
      })
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
